export default {
    data: function () {
        return {    
        }
    },
    methods: {
        parseTimePeriod(time){
          var aux = new Date(time) 
          let dateString = (new Date(aux.toString() + ' UTC')).toLocaleString() 
          return dateString
        }
    }
  };